var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-8",attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-overlay',[_c('AccessDeniedCard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }